export const getTraceHighlightStyles = (wasExecuted: boolean) =>
  wasExecuted ? 'border-accent border-2' : 'border-tertiary border';
